Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    alertBackgroundColorMediumError: tokens.themeSupportFillError,
    alertBackgroundColorMediumWarning: tokens.themeSupportFillWarning,
    alertBackgroundColorMediumSuccess: tokens.themeSupportFillSuccess,
    alertBackgroundColorMediumNeutral: tokens.themeDecorativeNeutralSubdued,
    alertBackgroundColorMediumTheme: tokens.themeSurfacePalette,
    alertBackgroundColorLargeError: tokens.themeSupportFillError,
    alertBackgroundColorLargeWarning: tokens.themeSupportFillWarning,
    alertBackgroundColorLargeSuccess: tokens.themeSupportFillSuccess,
    alertBackgroundColorLargeNeutral: tokens.themeDecorativeNeutralSubdued,
    alertBackgroundColorLargeTheme: tokens.themeSurfacePalette,
    alertIconColorError: tokens.themeSupportInkError,
    alertIconColorWarning: tokens.themeSupportInkWarning,
    alertIconColorSuccess: tokens.themeSupportInkSuccess,
    alertIconColorNeutral: tokens.themeInkSubdued,
    alertIconColorTheme: tokens.themeDecorativePaletteStrong,
    alertIconNameSmallError: "error-knockout",
    alertIconNameSmallWarning: "alert-knockout",
    alertIconNameSmallSuccess: "check-knockout",
    alertIconNameSmallNeutral: "info-knockout",
    alertIconNameSmallTheme: "info-knockout",
    alertIconNameXlargeError: "alert-error-xlarge",
    alertIconNameXlargeWarning: "alert-warning-xlarge",
    alertIconNameXlargeSuccess: "alert-success-xlarge",
    alertIconNameLargeError: "error",
    alertIconNameLargeWarning: "alert",
    alertIconNameLargeSuccess: "check-circle",
    alertIconNameLargeNeutral: "info",
    alertIconNameLargeTheme: "info",
    alertForegroundColorSmallDefault: tokens.themeInkDefault,
    alertForegroundColorMediumDefault: tokens.themeInkDefault,
    alertForegroundColorLargeDefault: tokens.themeInkDefault,
    alertForegroundColorXlargeDefault: tokens.themeInkDefault,
    alertLinkColorMedium: tokens.themeInkDefault,
    alertLinkColorLarge: tokens.themeInkDefault,
    alertTitleSmallFontSize: 14,
    alertTitleSmallFontWeight: 600,
    alertTitleSmallLineHeight: "18px",
    alertTitleMediumFontSize: 14,
    alertTitleMediumFontWeight: 600,
    alertTitleMediumLineHeight: "18px",
    alertTitleLargeFontSize: 16,
    alertTitleLargeFontWeight: 600,
    alertTitleLargeLineHeight: "24px",
    alertTitleXlargeFontSize: 24,
    alertTitleXlargeFontWeight: 600,
    alertTitleXlargeLineHeight: "32px",
    alertMessageSmallFontSize: 14,
    alertMessageSmallFontWeight: 400,
    alertMessageSmallLineHeight: "20px",
    alertMessageMediumFontSize: 14,
    alertMessageMediumFontWeight: 400,
    alertMessageMediumLineHeight: "20px",
    alertMessageLargeFontSize: 16,
    alertMessageLargeFontWeight: 400,
    alertMessageLargeLineHeight: "24px",
    alertMessageXlargeFontSize: 16,
    alertMessageXlargeFontWeight: 400,
    alertMessageXlargeLineHeight: "24px",
    alertBorderWidthMedium: 1,
    alertBorderWidthLarge: 1,
    alertBorderRadius: 4,
    alertBorderColorError: tokens.themeSupportBorderError,
    alertBorderColorWarning: tokens.themeSupportBorderWarning,
    alertBorderColorSuccess: tokens.themeSupportBorderSuccess,
    alertBorderColorNeutral: tokens.themeInkSubdued,
    alertBorderColorTheme: tokens.themeDecorativePaletteStrong,
    alertSpacingInsetMedium: 8,
    alertSpacingInsetLarge: 16,
    alertSpacingInsetXlarge: 16,
    alertSpacingHorizontalSmall: 8,
    alertSpacingHorizontalMedium: 8,
    alertSpacingHorizontalLarge: 16,
    alertSpacingHorizontalXlarge: 0,
    alertCloseButtonBackgroundOpacityHover: 10,
    alertCloseButtonBackgroundOpacityPressed: 26,
    alertCloseButtonBackgroundColorHover: tokens.themeInkDefault,
    alertCloseButtonBackgroundColorPressed: tokens.themeInkDefault,
    alertCloseButtonSpacingMobileLarge: 4,
    alertCloseButtonSpacingWebMedium: 0,
    alertCloseButtonSpacingWebLarge: 8,
    alertCloseButtonSpacingWebXlarge: 8,
    alertTitleSpacingEndDefault: 8,
    alertTitleSpacingEndXlarge: 0,
    alertSpacingVerticalXlarge: 24,
    alertMotionDuration: "200ms",
    alertMotionFunction: "ease",
    alertShadowOffsetX: 0,
    alertShadowOffsetY: 8,
    alertShadowBlur: 16,
    alertShadowSpread: 0,
    alertShadowColor: "#02080E",
    alertShadowOpacity: 10,
    alertFontSizeTitleSmall: 14,
    alertFontSizeTitleMedium: 14,
    alertFontSizeTitleLarge: 16,
    alertFontSizeTitleXlarge: 24,
    alertFontSizeMessageSmall: 14,
    alertFontSizeMessageMedium: 14,
    alertFontSizeMessageLarge: 16,
    alertFontSizeMessageXlarge: 16,
    alertFontWeightTitle: 600,
    alertFontWeightMessage: 400,
    alertLineHeightTitleSmall: "18px",
    alertLineHeightTitleMedium: "18px",
    alertLineHeightTitleLarge: "24px",
    alertLineHeightTitleXlarge: "32px",
    alertLineHeightMessageSmall: "20px",
    alertLineHeightMessageMedium: "20px",
    alertLineHeightMessageLarge: "24px",
    alertLineHeightMessageXlarge: "24px"
  }
};